import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcList } from '@one/react';

export type PocListProps = ComponentPropsWithoutRef<typeof OwcList>;

export const PocList = forwardRef<ElementRef<typeof OwcList>, PocListProps>((props, ref) => (
    <OwcList ref={ref} {...props} />
));

PocList.displayName = 'PocList';
